import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Heart } from "lucide-react";

export default function Favorites() {
  const [products, setProducts] = useState([]);
  const [favIds, setFavIds] = useState([]);

  const load = async () => {
    const { data } = await api.get("/favorites");
    setProducts(data);
    setFavIds(data.map((p) => p.id));
  };

  useEffect(() => { load(); }, []);

  const toggleFav = async (id) => {
    await api.post(`/favorites/${id}`);
    setProducts((prev) => prev.filter((p) => p.id !== id));
    setFavIds((prev) => prev.filter((x) => x !== id));
  };

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8">
      <h1 className="font-serif text-4xl font-semibold text-zinc-100 mb-6">Favorieten</h1>
      {products.length === 0 ? (
        <div data-testid="no-favorites" className="text-center py-24 rounded-xl border border-zinc-800 bg-zinc-900/40">
          <Heart className="h-10 w-10 text-zinc-700 mx-auto mb-4" />
          <p className="font-serif text-xl text-zinc-300">Nog geen favorieten</p>
          <Link to="/" className="inline-block mt-4 text-rose-400 hover:text-rose-300 text-sm">Ontdek advertenties</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} favorited={favIds.includes(p.id)} onToggleFav={toggleFav} />
          ))}
        </div>
      )}
    </div>
  );
}
